'use client';
import { forwardRef, useEffect, useRef } from 'react';

export default forwardRef(function TextInput({ className = '', readOnly = false, isFocused = false, ...props }, ref) {
    const input = ref ? ref : useRef();

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, []);

    return (
        <input
            {...props}
            className={
                'py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-main-color focus:ring-main-color disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 ' +
                className +
                (readOnly ? ' bg-gray-100 cursor-not-allowed' : '')
            }
            ref={input}
        />
    );
});
